import React from 'react'
import PropTypes from 'prop-types'
import { InputWrapper, InputStyled, InputError } from './styled'

const Input = ({ label, type, name, onChange, value, error, fullWidth, reference, noMargin, pink, maxLength }) => (
  <InputWrapper
    error={error}
    fullWidth={fullWidth}
    noMargin={noMargin}
  >
    <InputStyled
      placeholder={label}
      type={type}
      name={name}
      onChange={onChange}
      value={value}
      fullWidth={fullWidth}
      ref={reference}
      pink={pink}
      maxLength={maxLength}
    />
    <InputError>{error}</InputError>
  </InputWrapper>
)

Input.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  error: PropTypes.string,
  fullWidth: PropTypes.bool,
}

Input.defaultProps = {
  label: 'text',
  type: 'text',
  name: 'input',
  onChange: () => { },
  value: '',
  error: '',
  fullWidth: false,
}

export default Input
